import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  useFillTimeSheetMutation,
  useGetActivityJobsQuery,
} from "../store/query/applicants";

const useApplicationStatus = () => {
  const [filters, setFilters] = useState({
    status: 1,
    date_from: "",
    date_to: "",
    page: 1,
    type: "",
  });
  const { data, isLoading, refetch } = useGetActivityJobsQuery(filters);

  const [fillTimeSheet, { isLoading: isFillTimeSheet }] =
    useFillTimeSheetMutation();

  const fillTimeSheetJob = useCallback(
    async (values) => {
      const res = await fillTimeSheet(values);
      if (res?.data?.status === true) {
        toast.success(res?.data?.message);
        refetch();
      } else {
        toast.error("Failed to Fill TimeSheet");
      }
    },
    [fillTimeSheet, refetch],
  );

  useEffect(() => {
    refetch();
  }, [filters, refetch]);

  return {
    isLoading,
    data: data?.data,
    isFillTimeSheet,
    fillTimeSheetJob,
    filters,
    setFilters,
  };
};

export default useApplicationStatus;
